import SearchAdmin from './SearchAdmin';

export default SearchAdmin;
